import React, { useState, useMemo } from 'react';
import Navigation from '../components/Navigation';
import CharacterCard from '../components/CharacterCard';
import FilterBar from '../components/FilterBar';
import charactersData from '../data/characters.json';
import './Characters.css';

const Characters = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [filters, setFilters] = useState({
    species: 'all',
    gender: 'all',
    affiliation: 'all',
  });

  // Get unique values for filter options
  const species = useMemo(
    () => [...new Set(charactersData.map((char) => char.species))],
    []
  );
  const genders = useMemo(
    () => [...new Set(charactersData.map((char) => char.gender))],
    []
  );
  const affiliations = useMemo(
    () => [...new Set(charactersData.map((char) => char.affiliation))],
    []
  );

  // Filter characters based on search and filters
  const filteredCharacters = useMemo(() => {
    return charactersData.filter((character) => {
      // Search filter
      const matchesSearch =
        searchQuery === '' ||
        character.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        character.description?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        character.personality?.toLowerCase().includes(searchQuery.toLowerCase());

      // Filter by species
      const matchesSpecies =
        filters.species === 'all' || character.species === filters.species;

      // Filter by gender
      const matchesGender =
        filters.gender === 'all' || character.gender === filters.gender;

      // Filter by affiliation
      const matchesAffiliation =
        filters.affiliation === 'all' || character.affiliation === filters.affiliation;

      return (
        matchesSearch && matchesSpecies && matchesGender && matchesAffiliation
      );
    });
  }, [searchQuery, filters]);

  return (
    <div className="characters-page">
      <Navigation />
      <div className="page-header">
        <h1>Characters</h1>
        <p>Fighters, killers and survivors of the apocalypse</p>
      </div>
      <div className="container">
        <FilterBar
          searchQuery={searchQuery}
          onSearchChange={setSearchQuery}
          filters={filters}
          onFiltersChange={setFilters}
          species={species}
          genders={genders}
          affiliations={affiliations}
        />
        <div className="characters-grid">
          {filteredCharacters.length > 0 ? (
            filteredCharacters.map((character) => (
              <CharacterCard key={character.name} character={character} />
            ))
          ) : (
            <div className="no-results">
              <p>No characters found matching your criteria.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Characters;

